<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const mouseX = ref(typeof window !== 'undefined' ? window.innerWidth / 2 : 0)
const mouseY = ref(typeof window !== 'undefined' ? window.innerHeight / 2 : 0)
const glowX = ref(typeof window !== 'undefined' ? window.innerWidth / 2 : 0)
const glowY = ref(typeof window !== 'undefined' ? window.innerHeight / 2 : 0)
const isVisible = ref(false)

let rafId = null

const onMouseMove = (e) => {
  isVisible.value = true
  mouseX.value = e.clientX
  mouseY.value = e.clientY
}

const animateGlow = () => {
  // Efecto "Lerp" (Linear Interpolation)
  // Crea la "fricción" para que el brillo siga al cursor suavemente
  glowX.value += (mouseX.value - glowX.value) * 0.08
  glowY.value += (mouseY.value - glowY.value) * 0.08

  rafId = requestAnimationFrame(animateGlow)
}

onMounted(() => {
  window.addEventListener('mousemove', onMouseMove)
  animateGlow()
})

onUnmounted(() => {
  window.removeEventListener('mousemove', onMouseMove)
  if (rafId) cancelAnimationFrame(rafId)
})
</script>

<template>
  <!--
    - pointer-events-none: Evita que bloquee los clics en botones/links.
    - fixed top-0 left-0: Lo ancla a la pantalla.
    - -mt/ml-[300px]: Centra el div de 600x600 exactamente en el cursor.
    - mix-blend-screen: Hace que la luz interactúe de forma brillante con el fondo oscuro.
  -->
  <div
    class="pointer-events-none fixed top-0 left-0 w-[600px] h-[600px] -mt-[300px] -ml-[300px] rounded-full bg-neural-primary/10 blur-[150px] transition-opacity duration-1000 z-0 will-change-transform mix-blend-screen hidden md:block"
    :class="isVisible ? 'opacity-100' : 'opacity-0'"
    :style="{ transform: `translate3d(${glowX}px, ${glowY}px, 0)` }"
  ></div>
</template>